import type { ComponentProps } from "react";
import { cn } from "@/lib/utils";

/** The orik.sh mark: two opposing rounded brackets that form an "o". */
export function OrikMark({ className, ...props }: ComponentProps<"svg">) {
  return <svg viewBox="0 0 256 256" fill="currentColor" aria-hidden="true" className={cn("size-8", className)} {...props}>
    <path d="M146 38H98C64.863 38 38 64.863 38 98V146C38 162.569 44.716 177.569 55.574 188.426L89.515 154.485C87.343 152.314 86 149.314 86 146V98C86 91.373 91.373 86 98 86H146C149.314 86 152.314 87.343 154.485 89.515L188.426 55.574C177.569 44.716 162.569 38 146 38Z" />
    <path d="M110 218H158C191.137 218 218 191.137 218 158V110C218 93.431 211.284 78.431 200.426 67.574L166.485 101.515C168.657 103.686 170 106.686 170 110V158C170 164.627 164.627 170 158 170H110C106.686 170 103.686 168.657 101.515 166.485L67.574 200.426C78.431 211.284 93.431 218 110 218Z" />
  </svg>;
}

/** The mark beside the orik.sh name. */
export function OrikWordmark({ className }: { className?: string }) {
  return <span className={cn("flex items-center gap-2", className)}>
    <OrikMark className="size-8 text-primary" />
    <span className="text-xl font-semibold tracking-[-0.04em] text-foreground">orik.sh</span>
  </span>;
}
